<header
	[ngClass]="{ 'bg-transparent': isNegativeHeader() }"
	class="header sticky top-0 z-20 md:relative"
	data-test-id="header"
>
	<!--
		Only one of the two headers is visible per breakpoint (CSS). Both are
		server-rendered, but `hydrate on viewport` keeps the hidden one
		dehydrated: display:none never intersects, so on a phone the desktop
		header is never instantiated on the client (and vice versa) until a
		resize across `md` reveals it. `on immediate` keeps non-SSR consumers
		(Storybook, client-only apps) rendering as before.
	-->
	@defer (on immediate; hydrate on viewport) {
		<vp-header-desktop
			[cta]="resolvedCta()"
			[hideMenu]="hideMenu()"
			[isNegativeHeader]="isNegativeHeader()"
			[language]="language()"
			[menuItems]="menuItems()"
			[metaMenu]="metaMenu()"
			[title]="transformedTitle()"
			[variant]="variant()"
			(languageSwitch)="onLanguageSwitch($event)"
			class="hidden md:block"
		/>
	}
	@defer (on immediate; hydrate on viewport) {
		<vp-header-mobile
			[cta]="resolvedCta()"
			[hideMenu]="hideMenu()"
			[isNegativeHeader]="isNegativeHeader()"
			[menuItems]="menuItems()"
			[metaMenu]="metaMenu()"
			[title]="transformedTitle()"
			(languageSwitch)="onLanguageSwitch($event)"
			class="md:hidden"
		/>
	}
</header>
